import { Component, Input, OnInit } from '@angular/core';
import { ConvertDatePipe } from '../../filters/convert-date/convert-date.pipe';
import { NgArrayPipesModule } from 'ngx-pipes';
import { CentinelaFooterComponent } from '../centinela-footer/centinela-footer.component';

import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { NgShowDirective } from '../../directives/ng-show/ng-show.directive';
import { PdfHeaderComponent } from '../pdf-header/pdf-header.component';

@Component({
    selector: 'report-consult-lists-pdf',
    templateUrl: './report-consult-lists-pdf.component.html',
    standalone: true,
    imports: [PdfHeaderComponent, NgShowDirective, AfTranslateDirective, CentinelaFooterComponent, NgArrayPipesModule, ConvertDatePipe]
})
export class ReportConsultListsPdfComponent implements OnInit {
  constructor(){

  }

  @Input() configuration: any;

  ngOnInit(): void {
    console.log(this.configuration)
  }
}
